// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"dMWCoP3NTGWv18m7ZmQg","header":"Qk_JHpfFe_mMA54IQuQC","LoginModalContentSize":"D6pbBKasun9KiuPiEYK0","largeContentSize":"tMPfhZKbtlmWpHf3T2Ti"};